<template>
  <div>
    <img
      class="addIcon"
      :class="{ animating: !dragging }"
      draggable="false"
      :style="{ top: buttonPosition.top + 'px', left: buttonPosition.left + 'px' }"
      @mousedown="startDrag"
      @click="goAdd"
      src="@/assets/icons/icon_add_idea.png"
      alt=""
    />
    <a-modal title="意见反馈" width="515px" :visible="addShow" @ok="submitAdd" @cancel="addShow = false" wrapClassName="ideaAddModal">
      <a-form :form="form">
        <a-form-item label="功能模块">
          <a-tree-select
            v-decorator="['module']"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择功能模块"
            allow-clear
            :replaceFields="replaceFields"
            :tree-data="menuData"
          >
          </a-tree-select>
        </a-form-item>
        <a-form-item label="问题和建议">
          <div class="content">
            <a-textarea
              class="textarea"
              v-decorator="['content', { rules: [{ required: true, message: '请输入您遇到的问题或您要提的建议' }] }]"
              :auto-size="{ minRows: 3, maxRows: 6 }"
              maxLength="500"
              placeholder="请输入您遇到的问题或您要提的建议"
            ></a-textarea>
            <div class="num">
              <span>{{ form.getFieldValue('content') ? form.getFieldValue('content').length : 0 }}</span>
              <span>/500</span>
            </div>
          </div>
        </a-form-item>
        <a-form-item label="附件内容">
          <div v-decorator="['introVideoUrl', { rules: [{ required: true, message: '请上传附件' }] }]">
            <div class="attach" v-if="attach.filter(item => item.url).length > 0">
              <div class="list" v-for="(item, index) of attach" :key="index">
                <img :src="item.url" alt="" v-if="item.type === 'image'">
                <video :src="item.url" v-else-if="item.type === 'video'"></video>
                <div class="delete" v-if="item.url" @click="deleteAttach(index)">
                  <div>
                    <img src="@/assets/icons/delete.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            <Upload
              ref="upload"
              v-if="attach.filter(item => item.url).length < 5"
              @uploadData="e => uploadData(e, 'introVideoUrl')"
              :generateCover="false"
              :desc="['支持上传图片、视频，总数限制5个，大小限制10M以内']"
              :accept="['mp4', 'png', 'jpg', 'jpeg']"
              :fileMaxSize="10"
              class="uploadAttach"
            ></Upload>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import Upload from '@/components/upload/index.vue'
import { feedbackSave } from '@/api/message.js'

export default {
  components: { Upload },
  data() {
    return {
      addShow: false,
      form: this.$form.createForm(this),
      buttonPosition: { top: document.body.clientHeight - 100, left: 5 }, // 初始位置
      dragging: false,
      offsetX: 0,
      offsetY: 0,
      replaceFields: {
        children: 'child',
        title: 'name',
        key: 'name',
        value: 'id'
      },
      value: undefined,
      attach: []
    }
  },
  props: {
    menuData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    menuData() {
      this.menuData.forEach(item => {
        if (item.child) {
          item.child = item.child.filter(item => !item.hidden)
        }
      })
    }
  },
  methods: {
    goAdd() {
      if (!this.isClick) return
      this.addShow = true
      // 初始化表单
      this.form.resetFields()
      this.attach = []
      this.initAttach()
    },
    startDrag(event) {
      this.isClick = true
      // 设置 dragging 状态为 true
      this.dragging = true

      // 计算鼠标相对于按钮左上角的位置
      this.offsetX = event.clientX - this.buttonPosition.left
      this.offsetY = event.clientY - this.buttonPosition.top

      // 监听全局的鼠标移动和松开事件
      window.addEventListener('mousemove', this.drag)
      window.addEventListener('mouseup', this.stopDrag)
    },
    drag(event) {
      if (this.dragging) {
        // 更新按钮的位置，使其跟随鼠标移动，不能超出可视区域
        const left = event.clientX - this.offsetX
        const top = event.clientY - this.offsetY
        this.isClick = false
        this.buttonPosition.top = top < 0 ? 0 : top > document.body.clientHeight - 45 ? document.body.clientHeight - 45 : top
        this.buttonPosition.left = left < 0 ? 0 : left > document.body.clientWidth - 45 ? document.body.clientWidth - 45 : left
      }
    },
    stopDrag() {
      // 停止拖拽
      this.dragging = false

      // 移除事件监听器
      window.removeEventListener('mousemove', this.drag)
      window.removeEventListener('mouseup', this.stopDrag)

      // 将按钮的位置吸附到两边
      if (this.buttonPosition.left < document.body.clientWidth / 2) {
        this.buttonPosition.left = 5
      } else {
        this.buttonPosition.left = document.body.clientWidth - 50
      }
    },
    uploadData(data, type) {
      if (data.length === 0) return
      const url = data.length > 0 ? data[0].url : ''
      this.form.setFieldsValue({
        [type]: url
      })
      const hasAttachLength = this.attach.filter(item => item.url).length
      this.attach[hasAttachLength] = {
        name: data[0].name,
        url,
        type: data[0].type.indexOf('image') > -1 ? 'image' : 'video'
      }
      this.$refs.upload.deleteFile()
    },
    deleteAttach(index) {
      this.attach.splice(index, 1)
      this.attach.push({
        type: '',
        url: ''
      })
    },
    submitAdd() {
      console.log(this.value)
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let module
          for (const item of this.menuData) {
            if (item.id === values.module) {
              module = item.name
              break
            }
            if (item.child) {
              for (const it of item.child) {
                if (it.id === values.module) {
                  module = item.name + '-' + it.name
                  break
                }
              }
            }
          }
          const res = await feedbackSave({
            // module: values.module,
            module,
            content: values.content,
            attachments: this.attach.filter(item => item.url)
          })
          if (res.code === 200) {
            this.addShow = false
            this.$message.success('提交成功')
          }
        }
      })
    },
    initAttach() {
      for (let i = 0; i < 5; i++) {
        this.attach.push({
          type: '',
          url: ''
        })
      }
    }
  },
  mounted() {
    this.initAttach()
  }
}
</script>

<style scoped lang="less">
.addIcon {
  position: fixed;
  width: 45px;
  height: 45px;
  cursor: grab;
  z-index: 10;
}
.animating {
  transition: left 0.3s ease-in-out;
}
.content {
  position: relative;
  .textarea {
    background: #fcfcfc;
    border-radius: 4px;
    border: 1px solid #d8dce0;
    padding: 11px 17px;
    color: #000;
  }
  .num {
    position: absolute;
    right: 10px;
    bottom: 6px;
    font-size: 12px;
    color: #5e7a92;
    > span:first-child {
      color: #000;
    }
  }
}
.attach{
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-bottom: 10px;
  .list{
    width: 87px;
    height: 49px;
    background-image: url('~@/assets/img/upload_background.png');
    background-size: 100% 100%;
    position: relative;
    border-radius: 6px;
    overflow: hidden;
    img, video{
      width: 100%;
      height: 100%;
    }
    .delete{
      width: 100%;
      height: 100%;
      position: absolute;
      background: rgba(0, 0, 0, 0.6);
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      &:hover{
        opacity: 1;
      }
      > div{
        width: 14px;
        height: 14px;
        overflow: hidden;
        cursor: pointer;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
        &:hover img{
          transform: translateY(-60px);
          filter: drop-shadow(#FFA000 0 60px);
        }
      }
    }
  }
}
.uploadAttach{
  height: 128px;
  /deep/ .upload-file .ant-btn{
    padding: 0;
  }
}
</style>
<style lang="less">
div.ideaAddModal{
  .ant-modal{
    max-height: 100vh;
    overflow: auto;
    padding-bottom: 0;
  }
  .ant-modal .ant-modal-body{
    padding: 14px 24px 0px 24px;
  }
  .ant-modal .ant-modal-footer{
    padding-bottom: 28px;
    margin-bottom: 0;
    margin-top: 18px;
  }
  .ant-form-item{
    margin-bottom: 6px;
  }
}
</style>
